import React from 'react';
import { useLocation, Navigate } from 'react-router-dom';
import { useUser } from '../context/UserProvider';
import PropTypes from 'prop-types';
import LoadingScreen from './LoadingScreen';

function PrivateRoute({ children }) {
  const { user: kipUser, firebaseUser, initialized } = useUser();

  const location = useLocation();

  if (!initialized) {
    return <LoadingScreen />;
  }

  if (firebaseUser || kipUser) {
    return children;
  }

  const url = location.pathname + location.search + location.hash;
  localStorage.setItem('next', url);
  return <Navigate to="/login" state={{ next: url }} />;
}

PrivateRoute.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default PrivateRoute;
